import type { GetMessageResp } from "@/types/messages.ts";

/**
 * Whether the user can react to this message: a finished reply of okthx's, in a
 * feed they can act on, with the gate on. A reply that already carries their
 * reaction stays reactable, so they can change it.
 *
 * `readOnly` matters because a shared snapshot renders this same feed: a
 * reaction sent from it would land on the live thread it was copied from.
 */
export const canReactToMessage = (
  message: Pick<GetMessageResp, "type" | "status">,
  { reactionsEnabled, readOnly }: { reactionsEnabled: boolean; readOnly: boolean },
): boolean =>
  reactionsEnabled &&
  !readOnly &&
  message.type === "agentResponse" &&
  message.status === "completed";
